export default __webpack_public_path__ + "static/geetajayanti3-bec414b35ad1fdb15f7a6befcf60308f.jpg";